{
	"error": {
		"title": "Ops... Algo não saiu como planejado.",
		"description": "Não foi possível concluir."
	},
	"success": "Concluído com sucesso!"
}
